import { __rest, __assign } from 'tslib';
import React, { forwardRef, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import cn from 'classnames';
import { BaseModal, BaseModalContext } from '@alfalab/core-components-base-modal/esm';

var styles = {"component":"drawer__component_82vcb","customScrollbar":"drawer__customScrollbar_82vcb","rightPlacement":"drawer__rightPlacement_82vcb","leftPlacement":"drawer__leftPlacement_82vcb","content":"drawer__content_82vcb","enterRight":"drawer__enterRight_82vcb","enterLeft":"drawer__enterLeft_82vcb","contentEnter":"drawer__contentEnter_82vcb","backdropEnter":"drawer__backdropEnter_82vcb","enterActive":"drawer__enterActive_82vcb","backdropEnterActive":"drawer__backdropEnterActive_82vcb","backdropEnterDone":"drawer__backdropEnterDone_82vcb","contentEnterActive":"drawer__contentEnterActive_82vcb","exit":"drawer__exit_82vcb","backdropExit":"drawer__backdropExit_82vcb","contentExit":"drawer__contentExit_82vcb","exitActiveRight":"drawer__exitActiveRight_82vcb","exitActiveLeft":"drawer__exitActiveLeft_82vcb","backdropExitActive":"drawer__backdropExitActive_82vcb","backdropExitDone":"drawer__backdropExitDone_82vcb","contentExitActive":"drawer__contentExitActive_82vcb"};
require('./index.css')

var ANIMATION_DURATION = 600;
var DrawerContext = BaseModalContext;
var backdropProps = {
    transitionClassNames: {
        enter: styles.backdropEnter,
        appear: styles.backdropEnter,
        enterActive: styles.backdropEnterActive,
        appearActive: styles.backdropEnterActive,
        enterDone: styles.backdropEnterDone,
        appearDone: styles.backdropEnterDone,
        exit: styles.backdropExit,
        exitActive: styles.backdropExitActive,
        exitDone: styles.backdropExitDone,
    },
    timeout: ANIMATION_DURATION,
};
var contentProps = {
    classNames: {
        enter: styles.contentEnter,
        appear: styles.contentEnter,
        enterActive: styles.contentEnterActive,
        appearActive: styles.contentEnterActive,
        exit: styles.contentExit,
        exitActive: styles.contentExitActive,
    },
    timeout: ANIMATION_DURATION,
};
var Drawer = forwardRef(function (_a, ref) {
    var _b;
    var open = _a.open, className = _a.className, children = _a.children, contentTransitionProps = _a.contentTransitionProps, _c = _a.nativeScrollbar, nativeScrollbar = _c === void 0 ? true : _c, _d = _a.placement, placement = _d === void 0 ? 'right' : _d, restProps = __rest(_a, ["open", "className", "children", "contentTransitionProps", "nativeScrollbar", "placement"]);
    var isRightPlacement = placement === 'right';
    var isLeftPlacement = placement === 'left';
    var transitionProps = useMemo(function () {
        var _a, _b;
        var enterClassName = cn((_a = {},
            _a[styles.enterRight] = isRightPlacement,
            _a[styles.enterLeft] = isLeftPlacement,
            _a));
        var exitClassName = cn((_b = {},
            _b[styles.exitActiveRight] = isRightPlacement,
            _b[styles.exitActiveLeft] = isLeftPlacement,
            _b));
        return __assign({ classNames: {
                enter: enterClassName,
                appear: enterClassName,
                enterActive: styles.enterActive,
                appearActive: styles.enterActive,
                exit: styles.exit,
                exitActive: exitClassName,
            }, timeout: ANIMATION_DURATION }, restProps.transitionProps);
    }, [restProps.transitionProps, isLeftPlacement, isRightPlacement]);
    return (React.createElement(BaseModal, __assign({}, restProps, { scrollHandler: 'content', ref: ref, open: open, className: cn(styles.component, className, (_b = {},
            _b[styles.rightPlacement] = isRightPlacement,
            _b[styles.leftPlacement] = isLeftPlacement,
            _b[styles.customScrollbar] = !nativeScrollbar,
            _b)), transitionProps: transitionProps, backdropProps: __assign(__assign({}, backdropProps), restProps.backdropProps) }),
        React.createElement(CSSTransition, __assign({}, __assign(__assign({}, contentProps), contentTransitionProps), { appear: true, in: open }),
            React.createElement("div", { className: styles.content }, children))));
});
Drawer.displayName = 'Drawer';

export { ANIMATION_DURATION, Drawer, DrawerContext };
